<template lang='pug' src='./form.pug'></template>

<script>
import axios from 'axios'
import api from 'api'

export default {
  data: () => {
    return {
      first: '',
      phone: '',
      message: '',
      contactPermission: false,
      formSubmitted: false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          axios.post(api + '/rg-mail/v1/contact-form', {
            clientname: this.first,
            clientphone: this.phone,
            clientmessage: this.message
          }).then(e => {
            this.formSubmitted = true
          })
        }
      })
      .catch(() => {
        alert('Please make sure all fields are filled out correctly')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// form.vue?bc025252